import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Question, Questionnaire } from '@app/core/models/questionnaire.model';

@Component({
  selector: 'app-opinion-scale',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './opinion-scale.html',
  styleUrl: './opinion-scale.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => OpinionScale),
      multi: true
    }
  ]
})
export class OpinionScale implements OnInit {
  @Input() questionnaire: Questionnaire | null = null;
  @Input() question: Question | null = null;
  @Input() questionNumber: number = 0;
  @Input() isInvalid: boolean = false;
  @Input() errorMessage: string = '';
  @Input() formControl?: FormControl;

  @Output() answerChange = new EventEmitter<any>();

  selectedRating: number | null = null;
  disabled = false;
  scaleCount: number = 5;

  onChange = (value: number | null) => {};
  onTouched = () => {};

  ngOnInit() {
    if (this.question?.questionSpecificOptions) {
      const options = this.question.questionSpecificOptions;
      this.scaleCount = Number(options.scaleCount) || 5;
    }

    if (this.formControl) {
      this.formControl.valueChanges.subscribe(value => {
        this.selectedRating = value;
      });
    }
  }

  writeValue(value: number): void {
    this.selectedRating = value || null;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  selectRating(value: number, event: Event) {
    event.stopPropagation();
    this.selectedRating = value;
    this.onChange(value);
    this.onTouched();

    if (this.question?.questionId) {
      this.answerChange.emit({
        questionId: this.question.questionId,
        score: value
      });
    }

    if (this.formControl) {
      this.formControl.setValue(value);
      this.formControl.markAsTouched();
    }
  }

  toNumber(value: any): number {
    const num = Number(value);
    return isNaN(num) ? 0 : num;
  }

  getScaleArray(count: number): number[] {
    return Array.from({ length: count }, (_, i) => i + 1);
  }
}
